export const CALCULATOR_COUNTRY = {
  ENGLAND_OR_NORTHERN_IRELAND: 'England/NorthernIreland',
  SCOTLAND: 'Scotland',
  WALES: 'Wales'
};
